var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 12.74v3.912A2.355 2.355 0 0 1 9.609 19H1V1h8.609a2.355 2.355 0 0 1 2.348 2.348V7.26M7.261 10h10.174M14.109 13.326 17.435 10l-3.326-3.326"
  }))));
};
export default SvgLogout;